import WalletBaseStatItem from "./WalletBaseStatItem";

export default WalletBaseStatItem;